import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, IonicModule } from '@ionic/angular';
import { AuthProvider } from "../../providers/auth/auth";
//import { InAppBrowser } from '@ionic-native/in-app-browser';
import { HomePage } from '../home/home';
import { UserDataProvider } from '../../providers/user-data/user-data';
//import { RefdataProvider } from '../../providers/refdata/refdata';
//import { Platform } from '@ionic/angular';
import { ApploginPage } from '../applogin/applogin';
import { WebloginPage } from '../weblogin/weblogin';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Generated class for the LandingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-landing',
  templateUrl: 'landing.html',
  styleUrls: ['./landing.scss'],
  standalone: false
//  imports: [
//    CommonModule,
//    IonicModule,
//    FormsModule,
//    TranslateModule
//  ]
})
export class LandingPage implements OnInit, OnDestroy {
  public static PATH: string = 'landing';

  //private currentCode: string = '';

  constructor(
    public router: Router,
    private auth: AuthProvider,
    public alertCtrl: AlertController,
    private userData: UserDataProvider,
    private translateService: TranslateService) {
  }

  ngOnInit() {
    console.log('landing: Angular Init'); 
  }

  ionViewCanEnter(): boolean {
    console.log('landing: ionViewCanEnter called');
    return true;
  }

  ngAfterViewInit() {
    console.log('landing: ngAfterViewInit called');
  }

  ionViewWillEnter() {
    console.log('landing: ionViewWillEnter called');

    this.userData.init().then(() => {
      this.auth.isLoggedIn().then((loggedIn) => {
        console.log('landing: loggedIn = ' + loggedIn);
        if (!loggedIn) {
          loggedIn = this.auth.login(this);
          console.log('landing: loggedIn after auth.login = ' + loggedIn);
          if (!loggedIn) {
            this.showAuthWindow();
          }
        }
        else {
          this.showPage(HomePage);
        }
      });
    });
  }

  ionViewDidEnter() {
    console.log('landing: ionViewDidEnter called');
  }

  ionViewCanLeave(): boolean {
    console.log('landing: ionViewCanLeave called');
    return true;
  }

  ionViewWillLeave() {
    console.log('landing: ionViewWillLeave called');
  }

  ionViewDidLeave() {
    console.log('landing: ionViewDidLeave called');
  }

  ngOnDestroy() {
    console.log('landing: ngOnDestroy called');
  }

  public showPage(pageToShow) {
    this.router.navigate([ pageToShow.PATH ]).then(() => {
      // this.splashScreen.hide();
    })
    .catch(err => {
      let alertProm = this.alertCtrl.create({
        header: this.translateService.instant('LANDING.SHOWING_PAGE_FAILED'),
        subHeader: this.translateService.instant('LANDING.NO_ACCESS'),
        buttons: [this.translateService.instant('LANDING.OK')]
      });
      alertProm.then((alert) => alert.present());
    });
  }

  showAuthWindow() {
    if (this.auth.isInApp()) {
      this.showAuthWindowOnDevice();
    }
    else {
      this.showAuthWindowInBrowser();
    }
  }

  showAuthWindowOnDevice() {
    console.log("landing - showing in-app auth window");
    this.showPage(ApploginPage);
  }

  showAuthWindowInBrowser() {
    console.log("landing - showing auth window in browser");
    this.showPage(WebloginPage);
  }

  public showSuccessPage() {
    console.log("landing - showing successPage");
    this.showPage(HomePage);
  }

  public showNoAccessPage() {
    console.log("landing - showing noAccessPage");
    this.showPage(LandingPage);
  }

}
